<template>
  <div class="panel panel-default panel-dashboard">
    <loading-spinner v-if="loading"/>

    <div v-else class="panel-body text-center">
      <div class="row">
        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ result.attributes.value.impressions | number }}
          </p>

          <p style="margin-bottom: 0">
            Impressions
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ result.attributes.value.renders | number }}
          </p>

          <p style="margin-bottom: 0">
            Page views
          </p>
        </div>

        <div class="col-xs-6" style="border-right: 1px solid #e1e0e0">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ result.attributes.value.share_of_voice }}&nbsp;%
          </p>

          <p style="margin-bottom: 0">
            Share of voice
          </p>
        </div>

        <div class="col-xs-6">
          <p style="font-size: 36px; margin-bottom: 0">
            {{ readingTimeInHours }}:{{ readingTimeInMinutes }}&nbsp;hrs.
          </p>

          <p style="margin-bottom: 0">
            Time Spent with Brand
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import LoadingSpinner from "@/components/Layout/LoadingSpinner.vue";

export default {
  components: {LoadingSpinner},

  props: {
    portalCompanyId: {
      required: true,
    },

    filters: {
      required: true,
    },
  },

  data() {
    return {
      result: null,

      loading: true
    }
  },

  mounted() {
    this.load()
  },

  watch: {
    filters() {
      this.load()
    },
  },

  methods: {
    load() {
      http.get('/api/v2/portal-companies/' + this.portalCompanyId + '/statistics/featured/' + this.filters.from +'/' + this.filters.to).then(response => {
        this.result = response.data.data

        this.loading = false
      })
    }
  },

  computed: {
    readingTimeInHours() {
      return Math.floor(this.result.attributes.value.reading_time / 60 / 60)
    },

    readingTimeInMinutes() {
      const value = Math.floor(this.result.attributes.value.reading_time / 60) % 60

      return value < 10 ? '0' + value : value
    },
  }
}
</script>
